import styled from '@emotion/styled';
import Theme from '../../../themes/index';
import PropTypes from 'prop-types';

// Components
import BaseInput from './oc-input-base';

const EmailInput = ({
  className = "",
  defaultValue,
  disabled = false,
  error,
  errorIcon = null,
  helperText,
  infoFunction,
  label,
  name,
  themeColor = Theme.colors.brand,
  onBlur,
  onChange,
  placeholder,
  required = false,
  touched,
  valid = true,
  value
}) => {
  // const [emailError, setEmailError] = useState('')
  // const validateEmail = (value) => {};

  return (
    <BaseInput
      className={className}
      defaultValue={defaultValue}
      disabled={disabled}
      error={error}
      errorIcon={errorIcon}
      helperText={helperText}
      id={name}
      infoFunction={infoFunction}
      inputType="email"
      label={label}
      name={name}
      themeColor={themeColor}
      onBlur={onBlur}
      onChange={onChange}
      placeholder={placeholder}
      required={required}
      touched={touched}
      valid={valid}
      value={value}
    />
  );
}

export default EmailInput;

EmailInput.propTypes = {
  /* HTML: Sets the disabled attribute on the input */
  disabled: PropTypes.bool,
  /* HTML: Controls the display of the error text structure under the input */
  error: PropTypes.string,
  /* HTML: Additional text shown after the label, ex: "Required" */
  helperText: PropTypes.string,
  /* HTML: Label text displayed above the input */
  label: PropTypes.string,
  /* HTML: Sets the input name attribute */
  name: PropTypes.string,
  /* CSS: Hex value for color theme */
  themeColor: PropTypes.string,
  /* HTML: Sets the input placeholder text */
  placeholder: PropTypes.string,
  /* HTML: Determines whether or not the input is required */
  required: PropTypes.bool,
  /* JSX: Controls the error state of the input and display of error text and styles */
  valid: PropTypes.bool,
  /* HTML: Sets the default value of the input */
  value: PropTypes.string
}
